/** @format */
import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getModel(token) {
  const apiUrl = `${API_BASE_URL}/model/list`;

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      Authorization: token,
    },
  });

  return data.message.list;
}